import React, { PureComponent } from 'react';
import cx from 'classnames';
import {
  TranslateOutlined,
  FlagOutlined,
  ChatOutlined,
  BarChartOutlined,
  SettingsOutlined,
  PowerSettingsNewOutlined,
  Home,
  KeyboardArrowLeft,
  KeyboardArrowRight,
} from '@material-ui/icons';
import { Link, navigate } from '@reach/router';
import PropTypes from 'prop-types';
import axiosUI from '../../axiosUI';
import { withGlobalContext } from '../../App';
import './sidebar.scss';

class Sidebar extends PureComponent {
  static propTypes = {
    highlightNavItemIndex: PropTypes.number,
    shrinkSidebar: PropTypes.bool,
    toggleSidebar: PropTypes.func,
  };

  logout = async () => {
    try {
      await axiosUI.get('/logout');
      navigate('/login');
    } catch (error) {
      console.log(error);
    }
  };

  getLink = (path) => {
    if (this.props.savedCountry && this.props.savedLanguage) {
      return `${path}/${this.props.savedCountry}/${this.props.savedLanguage}`;
    } else {
      return path;
    }
  };

  render() {
    return (
      <nav
        className={cx('sidebar h-screen pin-t pin-x fixed bg-white', {
          shrink_sidebar: this.props.shrinkSidebar,
        })}>
        <Link
          to="/"
          className="logo no-underline block text-3xl h-16 pl-16 whitespace-no-wrap overflow-hidden relative italic font-light">
          {this.props.shrinkSidebar && (
            <div className="logo_icon absolute bg-transparent border-none pin-t pin-l outline-none text-center">
              <Home />
            </div>
          )}
          clippy
        </Link>
        <ul className="list-reset mt-0 mb-0 pt-8 overflow-hidden">
          <li className="nav__item relative">
            <Link
              className={cx('block h-12', {
                highlight_link: this.props.highlightNavItemIndex === 1,
              })}
              to={this.getLink('/translations')}>
              <div className="item__icon w-16 absolute h-12">
                <TranslateOutlined titleAccess="View all translations" />
              </div>
              <div className="item__text whitespace-no-wrap absolute h-12 text-base font-medium ff-roboto">
                Translations
              </div>
            </Link>
          </li>
          <li className="nav__item relative">
            <Link
              className={cx('block h-12', {
                highlight_link: this.props.highlightNavItemIndex === 2,
              })}
              to={this.getLink('/banners')}>
              <div className="item__icon w-16 absolute h-12">
                <FlagOutlined titleAccess="View all banners" />
              </div>
              <div className="item__text whitespace-no-wrap absolute h-12 text-base font-medium ff-roboto">
                Banners
              </div>
            </Link>
          </li>
          <li className="nav__item relative">
            <Link
              className={cx('block h-12', {
                highlight_link: this.props.highlightNavItemIndex === 3,
              })}
              to={this.getLink('/channeling')}>
              <div className="item__icon w-16 absolute h-12">
                <ChatOutlined titleAccess="View all channels" />
              </div>
              <div className="item__text whitespace-no-wrap absolute h-12 text-base font-medium ff-roboto">
                Channeling
              </div>
            </Link>
          </li>
          <li className="nav__item relative">
            <Link
              className={cx('block h-12', {
                highlight_link: this.props.highlightNavItemIndex === 4,
              })}
              to="/stats">
              <div className="item__icon w-16 absolute h-12">
                <BarChartOutlined />
              </div>
              <div className="item__text whitespace-no-wrap absolute h-12 text-base font-medium ff-roboto">
                Stats
              </div>
            </Link>
          </li>
          <li className="nav__item relative">
            <Link
              className={cx('block h-12', {
                highlight_link: this.props.highlightNavItemIndex === 5,
              })}
              to="/settings">
              <div className="item__icon w-16 absolute h-12">
                <SettingsOutlined titleAccess="View settings" />
              </div>
              <div className="item__text whitespace-no-wrap absolute h-12 text-base font-medium ff-roboto">
                Settings
              </div>
            </Link>
          </li>
          <li className="nav__item relative">
            <Link
              className={cx('block h-12', {
                highlight_link: this.props.highlightNavItemIndex === 6,
              })}
              onClick={this.logout}
              to="#">
              <div className="item__icon w-16 absolute h-12">
                <PowerSettingsNewOutlined titleAccess="Log out" />
              </div>
              <div className="item__text whitespace-no-wrap absolute h-12 text-base font-medium ff-roboto">
                Logout
              </div>
            </Link>
          </li>
        </ul>
        <button
          className="sidebar__toggle absolute bg-white border-none w-16 h-12 pin-r pin-b outline-none"
          onClick={this.props.toggleSidebar}>
          {this.props.shrinkSidebar ? (
            <KeyboardArrowRight />
          ) : (
            <KeyboardArrowLeft />
          )}
        </button>
      </nav>
    );
  }
}

export default  withGlobalContext(Sidebar);
